export default __webpack_public_path__ + "static/media/header__logo.aa006cd0.svg";